import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useTenant } from '../../contexts/TenantContext'
import { t } from '../../i18n'

function ProtectedRoute({ children, requiredRoles = [], superAdmin = false }) {
  const { isAuthenticated, user, isLoading } = useAuth()
  const location = useLocation()
  const tenant = useTenant()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="loading-spinner mx-auto mb-4"></div>
          <p className="text-gray-600">{t("Loading...")}</p>
        </div>
      </div>
    )
  }

  // The platform console lives on the main domain only.
  if (superAdmin && tenant.found && tenant.platformUrl) {
    window.location.replace(`${tenant.platformUrl}${location.pathname}`)
    return null
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />
  }

  if ((requiredRoles.length > 0 && !requiredRoles.includes(user.role)) || (superAdmin && !user.isSuperAdmin)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">403</h1>
          <p className="text-gray-600 mb-8">{t("Access denied")}</p>
          <p className="text-sm text-gray-500">{t("You don't have permission to access this page.")}</p>
        </div>
      </div>
    )
  }

  return children
}

export default ProtectedRoute